export default __webpack_public_path__ + "static/media/Luana_900.951cb506.webp";